import type { ConfigType } from '@plone/registry';
import customReducers from '../reducers';

export const applyReducersConfig = (config: ConfigType) => {
  config.addonReducers = {
    ...customReducers,
    ...config.addonReducers,
  };
};

export default applyReducersConfig;
